import { useParams } from 'react-router-dom';

import { Container } from '@occc-app/design-system';

import { usePreparedOfferHook } from '@occc-app/routes/CampaignComponents/component-details/use-prepared-offer.hook';
import { getLoyaltyEventDetailsPageHeaderLinks } from '@occc-app/routes/LoyaltyEvent/utils';
import { LoyaltyEventDetailsPage } from './LoyaltyEventDetailsPage';

export const LoyaltyEventDetailsPageContainer = () => {
  const { id: offerId = '' } = useParams<{ id: string }>();
  const { loading, error, offer, constraintSupplementalData } = usePreparedOfferHook(offerId);

  const getLoyaltyEventNameToDisplayInBreadcrumb = () => {
    if (error) {
      return 'Something went wrong';
    }

    if (loading && !offer) {
      return 'Loading...';
    }

    if (!offer) {
      return 'Page Not Found';
    }

    return offer.name;
  };

  const links = getLoyaltyEventDetailsPageHeaderLinks(
    getLoyaltyEventNameToDisplayInBreadcrumb(),
    offerId,
  );

  return (
    <Container>
      <LoyaltyEventDetailsPage
        offer={offer}
        constraintSupplementalData={constraintSupplementalData}
        loading={loading}
        error={error}
        links={links}
      />
    </Container>
  );
};
